import request from '../utils/request';

export function fetchAdminInfo() {
    return request.get('/info');
}
